import * as Types from '../../../generated/webapp_gql';

import { gql } from 'graphql.macro';
import * as React from 'react';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHoc from '@apollo/react-hoc';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions =  {}
export type GetMemberInformationQueryVariables = Types.Exact<{
  uuid: Types.Scalars['UUID'];
}>;


export type GetMemberInformationQuery = (
  { __typename?: 'Query' }
  & { member?: Types.Maybe<(
    { __typename?: 'MemberNode' }
    & Pick<Types.MemberNode, 'avatar' | 'uuid' | 'firstName' | 'lastName' | 'email' | 'birthDate' | 'languagePreferences' | 'joinedAt' | 'newEmailAddressNotConfirmed' | 'localTimezone' | 'insuranceStatus' | 'isCompanyHpiEnabled' | 'goalInterests'>
    & { intakeForm?: Types.Maybe<(
      { __typename?: 'IntakeFormNode' }
      & Pick<Types.IntakeFormNode, 'uuid' | 'exitedAt' | 'submitted' | 'completedAt'>
      & { completedBy?: Types.Maybe<(
        { __typename?: 'MemberNode' }
        & Pick<Types.MemberNode, 'firstName' | 'lastName'>
      )>, intakeFormQuestionResponses?: Types.Maybe<Array<Types.Maybe<(
        { __typename?: 'IntakeFormQuestionResponseNode' }
        & Pick<Types.IntakeFormQuestionResponseNode, 'uuid' | 'questionName' | 'questionResponseContent'>
      )>>> }
    )>, company?: Types.Maybe<(
      { __typename?: 'CompanyNode' }
      & Pick<Types.CompanyNode, 'coveredCoachingVisits' | 'coveredTherapyVisits' | 'name' | 'resetDate' | 'specificInfo'>
    )>, companyAdditionalBenefits?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'CompanyAdditionalBenefitNode' }
      & Pick<Types.CompanyAdditionalBenefitNode, 'id' | 'title' | 'description' | 'link' | 'topicsInCommon'>
    )>>>, careRecommendations: Array<(
      { __typename?: 'CareRecommendationNode' }
      & Pick<Types.CareRecommendationNode, 'uuid' | 'recommendation'>
      & { topicSelections: Array<(
        { __typename?: 'TopicSelectionNode' }
        & Pick<Types.TopicSelectionNode, 'uuid'>
        & { topicOfFocus: (
          { __typename?: 'TopicOfFocusNode' }
          & Pick<Types.TopicOfFocusNode, 'uuid' | 'name'>
        ), subtopicSelections: Array<(
          { __typename?: 'SubtopicSelectionNode' }
          & Pick<Types.SubtopicSelectionNode, 'uuid'>
          & { subtopicOfFocus: (
            { __typename?: 'SubtopicOfFocusNode' }
            & Pick<Types.SubtopicOfFocusNode, 'uuid' | 'name'>
          ) }
        )> }
      )> }
    )>, visitsRemaining?: Types.Maybe<(
      { __typename?: 'VisitsRemainingNode' }
      & Pick<Types.VisitsRemainingNode, 'coachingVisitsRemaining' | 'therapyVisitsRemaining'>
    )>, psychiatryVisitsCompleted?: Types.Maybe<(
      { __typename?: 'PsychiatryVisitsCompletedNode' }
      & Pick<Types.PsychiatryVisitsCompletedNode, 'initialEvaluationVisitsCompleted' | 'followUpVisitsCompleted'>
    )>, surveys: Array<(
      { __typename?: 'Who5SurveyNode' }
      & Pick<Types.Who5SurveyNode, 'id' | 'createdAt' | 'score'>
    )>, phq9SelfharmScores?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'Phq9SelfharmScoreNode' }
      & Pick<Types.Phq9SelfharmScoreNode, 'assessmentFlowId' | 'date' | 'score' | 'text'>
    )>>>, coachAssignments?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'CoachAssignmentNode' }
      & Pick<Types.CoachAssignmentNode, 'uuid'>
      & { coach?: Types.Maybe<(
        { __typename?: 'CoachNode' }
        & Pick<Types.CoachNode, 'uuid' | 'avatar' | 'firstName' | 'lastName' | 'email' | 'providerType' | 'psychiatristSubtype'>
      )>, coachingVisits: Array<(
        { __typename?: 'CoachingVisitNode' }
        & Pick<Types.CoachingVisitNode, 'isTherapy' | 'scheduledTime' | 'modalityType' | 'scheduledDuration' | 'actualDuration' | 'state' | 'visitInfo' | 'organizationImprovements' | 'isPsychiatryInitialEvaluation'>
        & { previousProviderReview?: Types.Maybe<(
          { __typename?: 'CoachingVisitProviderReviewNode' }
          & Pick<Types.CoachingVisitProviderReviewNode, 'abilityToHelpClient' | 'workedOnAgreedUponGoals' | 'clearPlanToWorkTowardGoals' | 'feedbackText'>
        )> }
      )> }
    )>>> }
  )> }
);


export const GetMemberInformationDocument = gql`
    query GetMemberInformation($uuid: UUID!) {
  member(uuid: $uuid) {
    avatar
    uuid
    firstName
    lastName
    email
    birthDate
    languagePreferences
    joinedAt
    newEmailAddressNotConfirmed
    localTimezone
    insuranceStatus
    isCompanyHpiEnabled
    intakeForm {
      uuid
      exitedAt
      submitted
      completedAt
      completedBy {
        firstName
        lastName
      }
      intakeFormQuestionResponses {
        uuid
        questionName
        questionResponseContent
      }
    }
    company {
      coveredCoachingVisits
      coveredTherapyVisits
      name
      resetDate
      specificInfo
    }
    companyAdditionalBenefits {
      id
      title
      description
      link
      topicsInCommon
    }
    careRecommendations {
      uuid
      recommendation
      topicSelections {
        uuid
        topicOfFocus {
          uuid
          name
        }
        subtopicSelections {
          uuid
          subtopicOfFocus {
            uuid
            name
          }
        }
      }
    }
    goalInterests
    visitsRemaining {
      coachingVisitsRemaining
      therapyVisitsRemaining
    }
    psychiatryVisitsCompleted {
      initialEvaluationVisitsCompleted
      followUpVisitsCompleted
    }
    surveys {
      id
      createdAt
      score
    }
    phq9SelfharmScores {
      assessmentFlowId
      date
      score
      text
    }
    coachAssignments {
      uuid
      coach {
        uuid
        avatar
        firstName
        lastName
        email
        providerType
        psychiatristSubtype
      }
      coachingVisits {
        isTherapy
        scheduledTime
        modalityType
        scheduledDuration
        actualDuration
        state
        visitInfo
        organizationImprovements
        isPsychiatryInitialEvaluation
        previousProviderReview {
          abilityToHelpClient
          workedOnAgreedUponGoals
          clearPlanToWorkTowardGoals
          feedbackText
        }
      }
    }
  }
}
    `;
export type GetMemberInformationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMemberInformationQuery, GetMemberInformationQueryVariables>, 'query'> & ({ variables: GetMemberInformationQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetMemberInformationComponent = (props: GetMemberInformationComponentProps) => (
      <ApolloReactComponents.Query<GetMemberInformationQuery, GetMemberInformationQueryVariables> query={GetMemberInformationDocument} {...props} />
    );
    
export type GetMemberInformationProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetMemberInformationQuery, GetMemberInformationQueryVariables>
    } & TChildProps;
export function withGetMemberInformation<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetMemberInformationQuery,
  GetMemberInformationQueryVariables,
  GetMemberInformationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetMemberInformationQuery, GetMemberInformationQueryVariables, GetMemberInformationProps<TChildProps, TDataName>>(GetMemberInformationDocument, {
      alias: 'getMemberInformation',
      ...operationOptions
    });
};

/**
 * __useGetMemberInformationQuery__
 *
 * To run a query within a React component, call `useGetMemberInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberInformationQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetMemberInformationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMemberInformationQuery, GetMemberInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMemberInformationQuery, GetMemberInformationQueryVariables>(GetMemberInformationDocument, options);
      }
export function useGetMemberInformationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMemberInformationQuery, GetMemberInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMemberInformationQuery, GetMemberInformationQueryVariables>(GetMemberInformationDocument, options);
        }
export type GetMemberInformationQueryHookResult = ReturnType<typeof useGetMemberInformationQuery>;
export type GetMemberInformationLazyQueryHookResult = ReturnType<typeof useGetMemberInformationLazyQuery>;
export type GetMemberInformationQueryResult = ApolloReactCommon.QueryResult<GetMemberInformationQuery, GetMemberInformationQueryVariables>;